import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { label: 'Overview', path: '/admin/sharepoint/inventory' },
  { label: 'File Explorer', path: '/admin/sharepoint/inventory/files' },
  { label: 'Crawl Health', path: '/admin/sharepoint/inventory/crawls' },
];

const InventoryNav: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <Nav variant="tabs" className="mb-3">
      {TABS.map((t) => (
        <Nav.Item key={t.path}>
          <Nav.Link as={Link} to={t.path} active={pathname === t.path}>
            {t.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default InventoryNav;
